import React from 'react';
import createReactClass from 'create-react-class';
import config from './config/shipmentsConfig';
import request from '../../helpers/request';
import setViewTitle from '../../helpers/setViewTitle';
import SimplePage from '../common/SimplePage';
import { Form, AdornedInput, Input } from '../common/Forms';
import ItemAutoComplete from '../common/AutocompleteText';
import itemConfig from '../items/config/itemConfig';
import AjaxInProgressHOC from '../common/AjaxInProgressHOC';

var NewShipment = createReactClass({

  getInitialState() {
    return {
      lines: []
    };
  },

  componentWillMount() {
    setViewTitle('Einlagerung ohne Bestellung');
  },

  onItemSelected(item) {
    this._itemAutoComplete.resetSelection();
    var lines = this.state.lines;

    var matchingLines = lines.filter(x => x.itemId === item.id);

    if(matchingLines.length == 0) {
      var shipmentLine = {
        itemId: item.id,
        itemName: item.name,
        stockUnitName: item.stockUnit,
        stockUnitQuantity: 0,
        storageLocationId: item.defaultStorageLocationId,
        storageLocationName: item.defaultStorageLocationName,
        lineNetPrice: 0,
      };

      lines.push(shipmentLine);
    }

    this.setState({
      lines: lines
    });
  },

  handleRemove(index) {
    var lines = this.state.lines;

    lines.splice(index, 1);

    this.setState({
      lines: lines
    }, () => setTimeout(() => this.form.validateForm(), 500)); // timeout is necessary to give formsy time to remove old components
  },

  handleSubmit(data) {

    // Formsy React produces errors when deleting lines, so we use the item id
    // as row identifier. Before submitting we need to transform the object to an array.
    let keys = Object.getOwnPropertyNames(data.lines);

    let payload = { lines: [] };
    for(let i = 0; i < keys.length; i++) {
      payload.lines[i] = data.lines[keys[i]];
    }

    request.post({
      url: config.apiUrl + 'newNoOrder',
      data: payload,
      success: () => {
        this.props.history.push('/items');
      }
    });
  },

  render() {
    var displayLines = this.state.lines.map((line, index) =>
      (
          <tr key={`${line.itemId}`} className="table-row-appear">
              <td className="col-md-2">{line.itemName}</td>
              <td className="col-md-1">{line.stockUnitName}</td>
              <td className="col-md-1">
                <Input name={`lines[${line.itemId}].itemId`} type="hidden" required value={line.itemId} />
                <AdornedInput
                  layout="elementOnly"
                  name={`lines[${line.itemId}].stockUnitQuantity`}
                  id={`lines[${line.itemId}].stockUnitQuantity`}
                  type="number"
                  value={line.stockUnitQuantity}
                  validations="isMoreThan:0"
                  required
                />
              </td>
              <td className="col-md-1">
                <AdornedInput
                  layout="elementOnly"
                  name={`lines[${line.itemId}].lineNetPrice`}
                  id={`lines[${line.itemId}].lineNetPrice`}
                  type="number"
                  addonBefore="€"
                  value={parseFloat(line.lineNetPrice).toFixed(2)}
                  validations="isMoreThan:0"
                  required
                />
              </td>
              <td className="col-md-2">
                {line.storageLocationName}

              </td>
              <td>
                  <a className="btn-sm btn-danger" onClick={this.handleRemove.bind(null, index)}><i className="fa fa-remove"></i> </a>
              </td>
          </tr>
      ));

    return (
      <SimplePage title="Artikelliste" icon="cube">

        <Form ref={c => this.form = c}
          submitButtonTitle="Artikel einlagern"
          backButtonLink="/purchaseorders/ordered/overview"
          isAjaxInProgress={this.props.isAjaxInProgress}
          onSubmit={this.handleSubmit}>
            <div className="table-responsive">
              <table className="table table-bordered table-striped">
                <thead>
                  <tr>
                    <th>Artikel</th>
                    <th>Einheit</th>
                    <th>Liefermenge</th>
                    <th>Preis (gesamt)</th>
                    <th>Lagerort</th>
                    <th>Aktionen</th>
                  </tr>
                </thead>
                <tbody>
                    {displayLines}
                    <tr>
                        <td style={{padding: 5}}>
                          <ItemAutoComplete
                            ref={c => this._itemAutoComplete = c}
                            dataUrl={itemConfig.itemsFastSearchUrl}
                            onSelect={this.onItemSelected}
                            searchPlaceholder="Artikel für Einlagerung hinzufügen"
                            idProp="id"
                            displayProp="name"
                            inputTooShortText="Geben Sie mind. 0 Zeichen ein"
                            noMatchesText="Kein Ergebnis"
                            searchInProgressText="Suche..."/>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                </tbody>
              </table>
            </div>
          </Form>
        </SimplePage>
    );
  }

});

export default AjaxInProgressHOC(NewShipment);



// WEBPACK FOOTER //
// ./src/components/shipments/NewShipmentWithoutOrder.js